import { TableColumnMeta } from "ds/components/Table/types";

export const AWS_TABLE_STORAGE_KEY = "awsIntegrationsTableStorageKey";
export const AWS_TABLE_FILTERS_STORAGE_KEY = "awsIntegrationsFiltersStorageKey";

export enum AWS_COLUMN_ID {
  TYPE = "TYPE",
  NAME = "NAME",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const AWS_TABLE_COLUMNS_CONFIG: Record<AWS_COLUMN_ID, TableColumnMeta> = {
  [AWS_COLUMN_ID.TYPE]: {
    id: AWS_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 70,
    defaultWidth: 70,
    maxWidth: 70,
    allowsSorting: false,
    resizable: false,
    canHide: true,
    configurable: true,
  },
  [AWS_COLUMN_ID.NAME]: {
    id: AWS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [AWS_COLUMN_ID.SPACE]: {
    id: AWS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [AWS_COLUMN_ID.DROPDOWN]: {
    id: AWS_COLUMN_ID.DROPDOWN,
    title: "More actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<AWS_COLUMN_ID, string> = {
  [AWS_COLUMN_ID.TYPE]: "type",
  [AWS_COLUMN_ID.NAME]: "name",
  [AWS_COLUMN_ID.SPACE]: "space",
  [AWS_COLUMN_ID.DROPDOWN]: "dropdown",
};
